import type { QueryClientConfig } from '@tanstack/react-query';

export const QUERY_CLIENT_CONFIG: QueryClientConfig = {
  defaultOptions: {
    queries: {
      retry: false,

      /**
       * @note
       * We need to disable background refetch (on window focus) to avoid a "Error 401" when making a background request to the server and being redirected to a 401 error page when the user's "session ended" pop-up is displayed.
       */
      refetchOnWindowFocus: false,

      /**
       * @note
       * 10 sec is a default time after data is considered stale (for all queries by default)
       */
      staleTime: 10 * 1000,
      throwOnError: (error) => {
        // @ts-expect-error
        return error?.response?.status == 401 || error?.status == 401 || error?.message?.includes?.('401');
      },
    },
    mutations: {
      retry: false,
      throwOnError: (error) => {
        // @ts-expect-error
        return error?.response?.status == 401 || error?.status == 401 || error?.message?.includes?.('401');
      },
    },
  },
};
